import type { FaireProductEntity } from "../../entity_types/product";

export const p_6tjnktqac2: FaireProductEntity = {
  token: "p_6tjnktqac2",
  type: "product",
  name: "Ellery Floral Dime Organza Maxi Dress",
  brandToken: "b_eiw5tz7npc",
  brandName: "Sugarlips",
  imageUrl:
    "https://cdn.faire.com/fastly/f458d0d78beccae2ce23ed4c601365814b161313bcbb3570d948000c8fe0fe57.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a21fc127e7d5a35a2f82a8d984a9371105eaa05758fc4d4df709ad4dd734fe53.jpeg",
    "https://cdn.faire.com/fastly/700269ea8c456e5ca081674a7fd57ee70a85310af2c50a8d626f2d5ebe72c65b.jpeg",
    "https://cdn.faire.com/fastly/5ff07b144722cbe0be0bd9e2c09cd860fec0c624a7eefd496ca55e26580cf7cb.jpeg",
    "https://cdn.faire.com/fastly/de2ab315fcbd9b252d55ab0a58c9f7244432484b9b66067fc101c55533e41aa2.jpeg",
    "https://cdn.faire.com/fastly/cbdb31be1a7bb075bb4dc88dd56e68d85d56480e487544b9ee62dc415abdf874.jpeg",
    "https://cdn.faire.com/fastly/abad1a2b59d3758f19701aea14e73044a63dc172ec08c47eea742c287f42ca24.jpeg",
    "https://cdn.faire.com/fastly/b4f43f35979f9823a014e72d171e756d0c303dba5ad74833fc066d75a63dc755.jpeg",
    "https://cdn.faire.com/fastly/5921b7c954c3cfbc143806eda6c8597a07852df7b5b87db96801572a62f479da.jpeg",
    "https://cdn.faire.com/fastly/e210eb1574c0c38242343dcbb85b025ce27ec3967ef0e9e51362b8d7292ad9a2.jpeg",
    "https://cdn.faire.com/fastly/178d6bfb136ebf49840ecbe24bffde041dc210622921b179de014157489180cc.jpeg",
  ],
  priceDollars: 224,
  description:
    'Chic from head to toe! It has sleek organza composition that lays on top of an adjustable spaghetti straps long cami dress, and a long-collared neck. Turn around to reveal an oversized bow detail at the back for an extra-dramatic finish!\n\n- Organza\n- Cami dress\n- Lined\n- Bow details\n- Color: Green Multi\n\nSize + Fit \n- Model is 5\'9 and wearing size XS\n- Measurements taken from size S \n- Chest: 19 1/4"\n- Length: 56 1/2"',
  tags: [],
  msrpDollars: 525,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:59.486Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
